import React from 'react';
import type { FragmentType } from '@graphql/reactQuery';
import { getFragment, WaveformInfoFragmentDoc } from '@graphql/reactQuery';
import { Waveform } from './Waveform';

export function ReleaseWaveform({
  release: releaseFragment,
  isTrackDisabled,
  showComments,
  showBottomHalf,
  enableTouchHandler,
}: {
  release: FragmentType<typeof WaveformInfoFragmentDoc>;
  isTrackDisabled: boolean;
  showComments: boolean;
  showBottomHalf: boolean;
  enableTouchHandler: boolean;
}) {
  const release = getFragment(WaveformInfoFragmentDoc, releaseFragment);
  const { track } = release;

  return (
    <Waveform
      track={{ ...track }}
      releaseFrag={release}
      isTrackDisabled={isTrackDisabled}
      showComments={showComments}
      showBottomHalf={showBottomHalf}
      enableTouchHandler={enableTouchHandler}
    />
  );
}
